import React from 'react';
import { IconType } from 'react-icons';
import { LuHouse } from 'react-icons/lu';

interface SubnavProps {
    subnavItems: {
        order?: number;
        label?: React.ReactNode;
        icon?: IconType;
        identifier: string;
        main?: boolean;
    }[];
    onChange: (key: string) => void;
    activeSubsection?: string;
}

/** Outer lg (16) − p-1.5 (6) → nested tab corners sit flush in the shell. */
const SUBNAV_TAB_RADIUS = 'rounded-[calc(var(--radius-lg)-0.375rem)]';

export const Subnav = (props: SubnavProps) => {
    return (
        <div
            id='subnav'
            className='w-full'>
            <div className='relative'>
                <ul
                    className='bg-background-surface relative flex list-none flex-wrap gap-1.5 rounded-lg p-1.5'
                    data-tabs='tabs'
                    data-squircle-managed='component'
                    role='list'>
                    {props.subnavItems.map((key) => {
                        const Icon = key.icon;
                        return (
                            <li
                                className='z-30 flex-auto text-center'
                                data-testid={`nav-item-${key.identifier}`}
                                onClick={() => props.onChange(key.identifier)}
                                key={key.identifier}>
                                <a
                                    className={`z-30 mb-0 flex h-full w-full cursor-pointer items-center justify-center gap-2 ${SUBNAV_TAB_RADIUS} focus-visible:outline-brand-accent border-0 px-2 py-2 text-sm transition-all ease-in-out focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                        props.activeSubsection === key.identifier.toLowerCase()
                                            ? 'bg-brand-light text-brand-primary'
                                            : 'text-brand-muted hover:bg-brand-primary/20 bg-inherit'
                                    }`}
                                    data-tab-target={key.identifier}
                                    role='tab'
                                    aria-selected={props.activeSubsection === key.identifier.toLowerCase()}>
                                    {Icon ? <Icon /> : <LuHouse />}
                                    {key.label ?? 'Basic'}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};
